import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollPrepareService {

    scrollDirection = new Subject();

    getScrollDirection() {
        return this.scrollDirection.asObservable();
    }
}
